import { DEFAULT_TEMPLATE, templateIdOf } from "./registry";
import { TEMPLATE_COMPONENTS } from "./templates";

/**
 * The invitation, drawn with the template the couple chose — the one renderer
 * behind both the guests' page (/events/:slug) and the editor's preview
 * (/preview). Only where the payload comes from and what happens around it
 * differ; see pages/RSVP.jsx and pages/Preview.jsx.
 *
 * Renders the nav and `.main`; the page around it supplies `.page-wrapper`.
 * Every other prop goes to the template (see templates/classic/ClassicInvitation.jsx).
 */
const InvitationView = ({ event, ...props }) => {
  const Template =
    TEMPLATE_COMPONENTS[templateIdOf(event?.invitation)] ??
    TEMPLATE_COMPONENTS[DEFAULT_TEMPLATE];
  return <Template event={event} {...props} />;
};

export default InvitationView;
